import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
import { useState, useEffect } from "react";
// material
import { Box, Card, CardHeader, Stack, Typography } from '@mui/material';
// utils
import { fNumber } from '../../../utils/formatNumber';
//
import { BaseOptionChart } from '../../charts';

// ----------------------------------------------------------------------



function AppPracticePrescriptions(props) {
  const [refreshGraph, setRefreshGraph] = useState(false);
  const [data, setData] = useState([]);
  const categories = [
    'Dublin and North East',
    'South West',
    'Mid West',
    'Dublin and South East',
    'West and North West',
    'Dublin and Midlands'
  ];

  const fillColor = "#3E8397";
  useEffect(() => {
    if (props.practices_data ) {
      const areaMap = {};
      if(props.practices_data.healthAreas){
        props.practices_data.healthAreas.forEach(area => {
          areaMap[area.name] = area.practiceCount;
        }); 
      }
      
      const chartData = categories.map(cat => ({
        x: cat,
        y: areaMap[cat] || 0,
        fillColor
      }));
      setData(chartData)
    }
  }, [props.practices_data]);
  
  const CHART_DATA_Prescriptions = [{
    name: 'Practices',
    data: data
  }];

  const chartOptionsPrescribe = merge(BaseOptionChart(), {
    chart: {
      type: 'bar',
      height: 350,
      stacked: false,
      stackType: "100%",
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: 'top',
        },
        barHeight: '70%',
        borderRadius: 5,
        borderRadiusApplication: "end",
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return fNumber(val);
      },
      offsetX: 20,
      style: {
        colors: ['#3E8397']
      }
    },
    xaxis: {
      labels: {
        show: false
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    yaxis: {
      labels: {
        style: {
          colors: "#22577A"
        }
      }
    },
    colors: CHART_DATA_Prescriptions[0].data.map(item => item.fillColor),
    tooltip: {
      y: {
        formatter: function (val) {
          return fNumber(val) + ' practices';
        }
      }
    }
  });

  return (
    <Card sx={{ boxShadow: 'none', mt: 4, height: 400 }}>
      <Typography variant="h4" color="#22577A" sx={{ mb: 2, px: 2 }}>
        General practices signed up in each HSE health region
      </Typography>
      <Box sx={{ p: 2, height: 350 }} dir="ltr">
        <ReactApexChart
          type="bar"
          series={CHART_DATA_Prescriptions}
          options={chartOptionsPrescribe}
          height={350}
          key={refreshGraph}
        />
      </Box>
    </Card>
  );
}

import { connect } from "react-redux";
const mapState = state => ({
  practices_data: state.overview.practices_data
});

const mapDispatch = ({
  overview: { loadData } }) => ({
    loadData: () => loadData()
  });

export default connect(mapState, mapDispatch)(AppPracticePrescriptions);
